import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../auth';
import { Link, Redirect } from 'react-router-dom';
import { startTrade } from './apiCore';
import ShowPrimaryPhoto from './ShowPrimaryPhoto';

const ChooseItemCard = ({selected, listing, itemToTrade}) => {
    const { token } = isAuthenticated();

    //handle selected toggle from this hook, not from the parent
    const [isSelected, setIsSelected] = useState(false);
    const handleToggle = () => {
        isSelected ? setIsSelected(false) : setIsSelected(true);
    };

    return (
        <div className='col-4 ml-1 mr-1 mb-1' onClick={handleToggle}>
            <div 
                className={`card ${isSelected ? 'border-info': ''}`}
            >
                <div className='card-header'>{listing.name}</div>
                <div className='card-body'>
                    <ShowPrimaryPhoto product={listing}/>
                    <p>{listing.description.substring(0,100)}</p>
                    <p>${listing.price}</p>
                </div>
            </div>
        </div>
    );
};

export default ChooseItemCard;
